<div *ngIf="showPageNotFound" class="page-not-found-container">
            <div class="page-not-found-message" style="max-width:420px;margin:60px auto;padding:32px 24px;background:#fff;border-radius:16px;box-shadow:0 4px 24px rgba(0,0,0,0.08);text-align:center;">
                <div class="page-not-found-svg" style="margin-bottom:24px;">
                                        <svg width="120" height="120" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="40" cy="40" r="40" fill="#f44336"/>
                                            <text x="40" y="48" text-anchor="middle" font-size="32" fill="#fff" font-weight="bold">404</text>
                                            <!-- <g>
                                                <circle cx="60" cy="60" r="8" fill="#fff"/>
                                                <rect x="56" y="56" width="8" height="2" rx="1" fill="#f44336" transform="rotate(45 60 60)"/>
                                            </g> -->
                                        </svg>
                </div>
                <h1 style="font-size:2.2rem;font-weight:700;color:#222;margin-bottom:12px;">Page Not Found</h1>
                <!-- <p style="font-size:1.1rem;color:#555;margin-bottom:24px;">This page will be available after <strong>12th Feb 2026, 18:00</strong>.<br>Please check back later or return to the homepage.</p> -->
                <p style="font-size:1.1rem;color:#555;margin-bottom:24px;">Please check back later or return to the homepage.</p>
                <button class="btn btn-danger" style="background:#f44336;border-color:#f44336;padding:12px 32px;font-size:1rem;border-radius:8px;box-shadow:0 2px 8px rgba(244,67,54,0.12);color:#fff;" (click)="redirectToHome()">Go to Home</button>
            </div>
</div>
<div *ngIf="!showPageNotFound" class="nfo-page-container row">
    <div class="nfo-product-description margin-bottom-35 col-lg-12 col-md-12 col-sm-12 col-xs-6">
        {{ nfoProductDetailList?.productValue.description }}
    </div>
    <div class="nfo-product-objective col-lg-12 col-md-12 col-sm-12 col-xs-6">
        {{ nfoProductDetailList?.productValue.objective }}
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-6 margin-top-100 margin-bottom-100 nfo-margin-top">
        <div id="carouselVideoIndicators" class="carousel slide" data-ride="carousel">
            <ol class="carousel-indicators">
                <li *ngFor="let vedio of nfoProductVedioList; let i = index" data-target="#carouselVideoIndicators"
                    class="{{ i === 0 ? 'active' : '' }}" attr.data-slide-to="{{ i }}">
                </li>
            </ol>
            <div class="carousel-inner">
                <div class="carousel-item" *ngFor="let vedio of nfoProductVedioList; let i = index" [ngClass]="{ active: i === 0 }">
                <h3 class="nfo-vedio-name">{{vedio?.name}}</h3>
                    <div class="nfo-video-iframe">
                        <img src="/assets/images/play.svg" (click)="palyVideo(vedio?.url)" class="play-btn">
                        <div class="nfo-video-img-center">
                            <img [src]="getVideoThumbnail(vedio?.urlMain)" async class="play-youtube-video" />
                        </div>
                    </div>
                </div>
            </div>
            <a
                class="carousel-control-prev"
                href="#carouselVideoIndicators"
                role="button"
                data-slide="prev"
            >
                <span
                    class="carousel-control-prev-icon"
                    aria-hidden="true"
                ></span>
                <span class="sr-only">Previous</span>
            </a>
            <a
                class="carousel-control-next"
                href="#carouselVideoIndicators"
                role="button"
                data-slide="next"
            >
                <span
                    class="carousel-control-next-icon"
                    aria-hidden="true"
                ></span>
                <span class="sr-only">Next</span>
            </a>
        </div>
    </div>
    <div class="nfo-key-feature col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="nfo-key-feature-heading">Our Fund's key features</div>
        <div class="row">
            <div
                class="nfo-key-feature-item col-lg-4 col-md-4"
                *ngFor="let key of nfoProductDetailList?.keyValue"
            >
                <div class="nfo-key-feature-item-icon-wrap">
                    <img
                        [src]="key.iconPath"
                        [alt]="key.keyHeading"
                    >
                </div>
                <div class="nfo-key-feature-item-content margin-top-35">
                    <h4>{{ key.keyHeading }}</h4>
                    <p>{{ key.keyFeature }}</p>
                </div>
            </div>
        </div>
    </div>
    <div class="nfo-productdocuments col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-top-100">
        <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <img
                    src="assets/images/Scheme-Documents.jpg"
                    alt="Scheme-Documents"
                    class="img-fluid"
                >
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 nfo-productdocument-items">
                <h1>Scheme Documents</h1>
                <div
                    class="nfo-productdocument-items-content"
                    *ngFor="let document of nfoProductDetailList?.productDocuments"
                >
                    <p>{{ document.documentsTitle }}</p>
                    <span>
                        <a
                            href="{{ document.documentsUrl }}"
                            target="_blank"
                        >
                            <img
                                src="assets/svg/PDF.svg"
                                alt="pdfIcon"
                                class="nfo-docs-pdf-icon"
                            >
                        </a>
                    </span>
                </div>
            </div>
        </div>
    </div>
    <div class="nfo-prduct-label margin-top-100 col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="row nfo-prduct-label-item">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 nfo-prduct-label-item-title">
                <h1>Product Label</h1>
                <h4 class="margin-top-50">{{ productLabel.title }}</h4>
                <ul class="margin-top-40">
                    <li *ngFor="let plItem of productLabel?.items">{{ plItem }}</li>
                </ul>
                <p class="margin-top-40">
                    *Investors should consult their financial advisers if in doubt about
          whether the product is suitable for them.
                </p>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 nfo-prduct-label-item-riskometer">
                <div class="scheme-risk-factor">
                <img
                    *ngIf="nfoProductDetailList?.productValue.risk === 'Moderately High'"
                    src="assets/riskoMeter/schemes/moderateHigh.png"
                    alt="nfo_moderateHigh"
                >
                <img
                    *ngIf="nfoProductDetailList?.productValue.risk === 'High'"
                    src="assets/riskoMeter/schemes/high.png"
                    alt="nfo_High"
                >
                <img
                    *ngIf="nfoProductDetailList?.productValue.risk === 'Very High'"
                    src="assets/riskoMeter/schemes/Very_High.png"
                    alt="nfo_Very_High"
                >
                <img
                *ngIf="nfoProductDetailList?.productValue.risk === 'Low'"
                src="assets/riskoMeter/schemes/low.png"
                alt="nfo_Low"
                >
                <img
                *ngIf="nfoProductDetailList?.productValue.risk === 'Moderate'"
                src="assets/riskoMeter/schemes/ModerateRisk.png"
                alt="nfo_moderate"
                >
                <img
                *ngIf="nfoProductDetailList?.productValue.risk === 'Low to Moderate'"
                src="assets/riskoMeter/schemes/Low_to_Moderate.png"
                alt="nfo_Moderataly_Low"
                >
                <p *ngIf="nfoProductDetailList?.productValue?.scheme">Scheme Name - {{nfoProductDetailList?.productValue?.scheme}}</p>
                </div>
                <div class="scheme-risk-factor">
                    <img *ngIf="nfoProductDetailList?.productValue.benchMarkRisk === 'Moderately High'"
                    src="assets/riskoMeter/benchmarks/moderateHigh.png" alt="nfo_moderateHigh">
                    <img *ngIf="nfoProductDetailList?.productValue.benchMarkRisk === 'High'" src="assets/riskoMeter/benchmarks/high.png"
                        alt="nfo_High">
                    <img *ngIf="nfoProductDetailList?.productValue.benchMarkRisk === 'Very High'"
                    src="assets/riskoMeter/benchmarks/Very_High.png" alt="nfo_Very_High">
                    <img *ngIf="nfoProductDetailList?.productValue.benchMarkRisk === 'Low'" src="assets/riskoMeter/benchmarks/low.png"
                        alt="nfo_Low">
                    <img *ngIf="nfoProductDetailList?.productValue.benchMarkRisk === 'Moderate'"
                    src="assets/riskoMeter/benchmarks/ModerateRisk.png" alt="nfo_moderate">
                    <img *ngIf="nfoProductDetailList?.productValue.benchMarkRisk === 'Low to Moderate'"
                    src="assets/riskoMeter/benchmarks/Low_to_Moderate.png" alt="nfo_Moderataly_Low">
                    <p *ngIf="nfoProductDetailList?.productValue?.benchMark"> Benchmark Name –
                        {{nfoProductDetailList?.productValue?.benchMark}}</p>
                </div>
        </div>
    </div>
    <div class="nfo-invest-online col-lg-12 col-md-12 col-sm-6 col-xs-6 margin-top-50">
        <button
            type="button"
            class="btn btn-primary btn-lg"
            (click)="investOnline()"
        >
            Invest Now
        </button>
    </div>
</div>
